import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/60">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex flex-col items-center md:items-start gap-2">
            <Link
              to="/"
              className="font-heading text-xl font-bold tracking-tight text-foreground-900 hover:text-accent-500 transition-colors"
            >
              Kakobuy<span className="text-accent-500">Polska</span>
            </Link>
            <p className="text-xs text-foreground-500 text-center md:text-left">
              Największy polski przewodnik Kakobuy Spreadsheet &copy; 2026
            </p>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-6">
            <a
              href="#categories"
              className="text-sm text-foreground-600 hover:text-accent-500 transition-colors whitespace-nowrap"
            >
              Kategorie
            </a>
            <a
              href="#about"
              className="text-sm text-foreground-600 hover:text-accent-500 transition-colors whitespace-nowrap"
            >
              O Spreadsheet
            </a>
            <a
              href="#safety"
              className="text-sm text-foreground-600 hover:text-accent-500 transition-colors whitespace-nowrap"
            >
              Bezpieczeństwo
            </a>
            <Link
              to="/artykul/kakobuy-spreadsheet-polska-poradnik"
              className="text-sm text-foreground-600 hover:text-accent-500 transition-colors whitespace-nowrap"
            >
              Poradnik
            </Link>
          </div>

          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-5 py-2 bg-accent-500 text-background-50 rounded-full text-sm font-semibold hover:bg-accent-600 transition-all whitespace-nowrap cursor-pointer"
          >
            Kakobuy Spreadsheet
          </a>
        </div>

        <div className="mt-8 pt-6 border-t border-background-200/60 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400">
            KakobuyPolska.beer &mdash; Niezależny przewodnik dla użytkowników Kakobuy
          </p>
          <div className="flex items-center gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="text-xs text-foreground-400 hover:text-accent-500 transition-colors whitespace-nowrap"
            >
              kaspreadsheet.com
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}